import { BaseOptionsCacheCheckerAndLoader } from '@pages/AdditionalServices/containers/services/optionsCacheCheckerAndLoader/baseOptionsCacheCheckerAndLoader';
import { HandbookProcessor } from '@pages/AdditionalServices/containers/services/optionsCacheCheckerAndLoader/handbookProcessor';
import { LocationProcessor } from '@pages/AdditionalServices/containers/services/optionsCacheCheckerAndLoader/locationProcessor';
import { TotalLoadingProcessor } from '@pages/AdditionalServices/containers/services/optionsCacheCheckerAndLoader/totalLoadingProcessor';

import { EcoFeePackageProcessor } from './ecoFeePackageProcessor';
import { EcoFeeProductProcessor } from './ecoFeeProductProcessor';

// optionsCacheCheckerAndLoader реализует фабрику сервиса
const optionsCacheCheckerAndLoader = () =>
  new BaseOptionsCacheCheckerAndLoader([
    new HandbookProcessor(),
    new TotalLoadingProcessor('currency'),
    new TotalLoadingProcessor('tax'),
    new TotalLoadingProcessor('consulting_contractor'),
    new TotalLoadingProcessor('certification_contractor'),
    new TotalLoadingProcessor('inspection_contractor'),
    new TotalLoadingProcessor('customs_contractor'),
    new TotalLoadingProcessor('insurance_contractor'),
    new LocationProcessor(),
    new EcoFeePackageProcessor(),
    new EcoFeeProductProcessor(),
  ]);

export default optionsCacheCheckerAndLoader;
